import MailSetting from "../../../../domain/mail/setting/MailSetting";
import {
  ACTION_TYPE,
  MailSettingAction,
  SetMailSettingAction,
  SetMailSettingFooterAction,
  SetMailSettingReplyToAction
}                  from "./MailSettingAction";

const reduceMailSetting = (action: SetMailSettingAction): MailSetting => action.mailSetting;
const reduceMailSettingFrom = (state: MailSetting, action: SetMailSettingReplyToAction): MailSetting => new MailSetting(action.mailReplyTo, state.footer);
const reduceMailSettingFooter = (state: MailSetting, action: SetMailSettingFooterAction): MailSetting => new MailSetting(state.replyTo, action.mailFooter);
const mailSettingReducer = (state: MailSetting = new MailSetting(), action: MailSettingAction): MailSetting => {
  switch (action.type) {
    default:
      return state;
    case ACTION_TYPE.SET_MAIL_SETTING:
      return reduceMailSetting(action as SetMailSettingAction);
    case ACTION_TYPE.SET_MAIL_SETTING_FROM:
      return reduceMailSettingFrom(state, action as SetMailSettingReplyToAction);
    case ACTION_TYPE.SET_MAIL_SETTING_FOOTER:
      return reduceMailSettingFooter(state, action as SetMailSettingFooterAction);
  }
};

export default mailSettingReducer;
